const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

const isBrowserProduction =
  typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  !["localhost", "127.0.0.1"].includes(window.location.hostname);

const isLocalNetworkUrl = (value) => {
  if (!value) return false;
  try {
    const { hostname } = new URL(value);
    return (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname === "0.0.0.0" ||
      hostname === "::1" ||
      hostname === "[::1]" ||
      hostname.startsWith("192.168.") ||
      hostname.startsWith("10.") ||
      /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname)
    );
  } catch {
    return false;
  }
};

export const API_BASE_URL =
  isBrowserProduction && isLocalNetworkUrl(configuredApiBaseUrl) ? "" : configuredApiBaseUrl;

const localApiPathFromUrl = (value) => {
  if (!value) return "";
  try {
    const parsed = new URL(value);
    if (!isLocalNetworkUrl(value) || !parsed.pathname.startsWith("/api/")) {
      return "";
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return "";
  }
};

export const normalizeApiMediaUrl = (value) => {
  if (!value) return value;
  const localPath = localApiPathFromUrl(value);
  if (localPath) {
    return API_BASE_URL ? `${API_BASE_URL}${localPath}` : localPath;
  }
  if (isBrowserProduction && isLocalNetworkUrl(value)) {
    return "";
  }
  if (value.startsWith("/api/")) {
    return API_BASE_URL ? `${API_BASE_URL}${value}` : value;
  }
  return value;
};
